export const B3CompanyStatus = {
  PENDING: '0',
  APPROVED: '1',
  REJECT: '2',
}

export const B3Role = {
  ADMIN: '0',
  SENIOR: '1',
  JUNIOR: '2',
  SALESREP: '3',
}

export const b3ExtraFieldTypes = {
  0: 'text',
  1: 'number',
  2: 'multiline',
}

export const B3AddressBookPermission = {
  isAllow: '1',
  isEnabled: '1',
}

export const B3PaymentMethodPermission = {
  isEnabled: '1',
}